import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const WSMRLLoadable = Loadable({
    loader: (): any => import('./WSMRL').then((res) => res.WSMRL),
    loading: <Loader/>,
});
